import React from 'react';
import cn from 'classnames';
import { useFormikContext, getIn } from 'formik';

import { getTranslation } from 'helpers/getTranslation';

import { FormikField } from 'components/FormikField';
import { EditableTextField } from 'components/FormikFields';

import styles from './MarkerListBlock.module.scss';

const MarkerListBlock = ({
  readOnly,
  namePrefix,
  onKeyDown,
}: {
  readOnly: any;
  namePrefix: any;
  onKeyDown: any;
}) => {
  const { values } = useFormikContext();

  const items = getIn(values, `${namePrefix}.data`);

  return (
    <div className={cn(styles.block, { [styles.readOnlyBlock]: readOnly })}>
      {items.map((_: any, itemIndex: any) => (
        <div className={styles.item}>
          <div className={styles.itemOrder} />
          <FormikField
            name={`${namePrefix}.data[${itemIndex}]`}
            withControl={false}
            component={EditableTextField}
            componentProps={{
              className: styles.itemText,
              readOnly,
              variant: 'text',
              autoFocus: true,
              placeholder: getTranslation(
                'components.theory_blocks.list_placeholder',
              ),
              onKeyDown: (event: any) => onKeyDown(event, itemIndex),
            }}
          />
        </div>
      ))}
    </div>
  );
};

export default React.memo(MarkerListBlock) as any;
